import {useMemo} from 'react';
import {getDateFormat, getHourMinutes} from '../../../library/dates';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';

const formatTime = (timestamp: number) => getHourMinutes(timestamp);
const getDayKey = (timestamp: number) => getDateFormat(timestamp, 'YYYY-M-D');

type ConferenceDay = {key: string; label: string; timestamp: number};

export function useTimeGroups(lectures: TTimetableItem[], currentDay: ConferenceDay | undefined) {
    return useMemo(() => {
        const filtered = currentDay
            ? lectures.filter(l => getDayKey(l.time) === currentDay.key)
            : lectures;

        const lectureItems: TTimetableItem[] = [];
        const breakItems: TTimetableItem[] = [];
        for(const item of filtered) {
            (item.isBreak ? breakItems : lectureItems).push(item);
        }

        const groupsMap = new Map<string, {time: string; rawTime: number; lectures: TTimetableItem[]}>();
        for(const lecture of lectureItems) {
            const timeKey = formatTime(lecture.time);
            const group = groupsMap.get(timeKey) ?? {time: timeKey, rawTime: lecture.time, lectures: []};
            group.lectures.push(lecture);
            groupsMap.set(timeKey, group);
        }
        const grouped = Array.from(groupsMap.values());

        const breakGroups = breakItems.map(b => ({
            time: formatTime(b.time),
            rawTime: b.time,
            isBreak: true as const,
            breakItem: b,
        }));

        return [...grouped, ...breakGroups].sort((a, b) => a.rawTime - b.rawTime);
    }, [lectures, currentDay]);
}
